import React from 'react';
import { Link } from 'gatsby';
import LitImage from '../components/images/LitImage';
import LitStructuredText from '../components/generic/LitStructuredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
const ArticleContainer = ({
  content,
  data,
  currentSlug,
  dateOptions,
  previous,
  next,
  pageSlug,
  defaultImage,
}) => {
  return (
    <>
      <div className="article-container">
        <div className="article-inner-body">
          {/* <h2 className="article-heading">{blogData.title}</h2> */}
          {/* <span className="article-date-time">{currentDateTime}</span> */}
          <div className="article-content">
            <LitStructuredText data={content} basic />
          </div>
        </div>
        <div className="recent-article-container">
          <h4>Recent Articles</h4>
          {data
            .filter(({ slug }) => slug !== currentSlug)
            .map(({ title, previewImage, publishedDate, slug }) => {
              return (
                <Link to={`/${pageSlug}/${slug}/`}>
                  <div className="recent-article-inner">
                    <div className="recent-article-image">
                      <LitImage
                        image={previewImage ?? defaultImage}
                        alt="blog preview image"
                      />
                    </div>
                    <h5>{title}</h5>
                    <span>
                      {new Date(publishedDate).toLocaleString([], dateOptions)}
                    </span>
                  </div>{' '}
                </Link>
              );
            })
            .slice(0, 5)}
        </div>
      </div>
      <div className="article-button-container">
        {previous && (
          <Link className="button-blue" to={`/${pageSlug}/${previous}/`}>
            <span>
              <FontAwesomeIcon icon={faChevronLeft} />
            </span>
            Previous
          </Link>
        )}
        {next && (
          <Link className="button-blue" to={`/${pageSlug}/${next}/`}>
            Next
            <span>
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          </Link>
        )}
      </div>
    </>
  );
};

export default ArticleContainer;
